import {Directive, ElementRef, HostListener, Renderer2} from '@angular/core';

@Directive({
  selector: '[copy]',
  standalone: true,
})
export class HeroCopyDirective {

  constructor(private el: ElementRef, private renderer: Renderer2) {
  }

  decodeHtmlEntities(encodedStr: string): string {
    const textArea = document.createElement("textarea");
    textArea.innerHTML = encodedStr;
    return textArea.value;
  }

  @HostListener('click')
  copyToClipboard() {
    const text = this.decodeHtmlEntities(this.el.nativeElement.innerHTML.trim());
    navigator.clipboard.writeText(text)
      .then(() => {
        console.log('Copied to clipboard:', text);
      })
      .catch(err => {
        console.error('Failed to copy:', err);
      });
  }

  @HostListener('mouseenter') onMouseEnter() {
    this.renderer.setStyle(this.el.nativeElement, 'cursor', 'pointer');
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.renderer.setStyle(this.el.nativeElement, 'cursor', 'default');
  }
}
